module.exports = __webpack_public_path__ + "static/img/leaf1@2x.bf99bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/leaf1@2x.png
// module id = 6Asj
// module chunks = 0